import { StatisticQuery } from '@osos/shared/api';
import {
  DashboardEntryPresenterModel,
  StatisticQueryPresenterModel,
} from '@osos/shared/types';

// tslint:disable-next-line: no-namespace
export namespace DashboardActions {
  export class updateDashboard {
    static readonly type = '[Dashboard] Update Dashboard';
    constructor(
      public payload: {
        moduleId: string;
        entityId: string;
        dashboard: DashboardEntryPresenterModel;
      },
    ) {}
  }

  export class fetchAndSelect {
    static readonly type = '[Dashboard] Fetch Dashboard';
    constructor(
      public moduleId: string,
      public entityId: string,
    ) {}
  }

  export class FetchAndSelectDashboard {
    static readonly type = '[Dashboard] Fetch Dashboard';
    constructor(
      public moduleId: string,
      public entityId: string,
      public viewId?: string,
    ) {}
  }

  export class TransitoryExecuteStatisticQuery {
    static readonly type =
      '[Dashboard] Transitory Execute Statistics Result By Id  ';
    constructor(
      public entityId: string,
      public queryId: string,
      public filterField?: string,
      public startDate?: Date,
      public toDate?: Date,
      public forceRefresh = false,
    ) {}
  }

  export class TransitoryFetchStatisticQuery {
    static readonly type =
      '[Dashboard] Transitory Fetch Statistics Result By Id  ';
    constructor(public queryId: string) {}
  }

  export class FetchStatisticQueries {
    static readonly type = '[Dashboard] Fetch Statistic Queries';
    constructor(
      public payload: string,
      public skip = 0,
      public limit: number = Number.MAX_SAFE_INTEGER,
    ) {}
  }

  export class FetchStatisticQuery {
    static readonly type = '[Dashboard] Fetch Core Statistic Query';
    constructor(
      public entity: string,
      public id: string,
      public cached = true,
    ) {}
  }
  export class CreateStatisticQuery {
    static readonly type = '[Dashboard] Create Core Statistic Query';
    constructor(public payload: StatisticQuery) {}
  }
  export class UpdateStatisticQuery {
    static readonly type = '[Dashboard] Update Core Statistic Query';
    constructor(public payload: StatisticQueryPresenterModel) {}
  }

  export class DeleteStatisticQuery {
    static readonly type = '[Dashboard] Delete Core Statistic Query';
    constructor(public payload: { entity: string; id: string }) {}
  }

  export class ClearPresentedStatisticQueryByQuerySource {
    static readonly type =
      '[Core Statistic Query] Clear Presented Statistic Query By Query Source';
    constructor(
      public dataEntityId?: string,
      public dataQueryId?: string,
    ) {}
  }

  export class ClearPresentedStatisticByEntityId {
    static readonly type =
      '[Core Statistic Query] Clear Presented Statistic Query By Entity Id';
    constructor(public dataEntityId?: string) {}
  }

  export class ClearPresentedStatistic {
    static readonly type =
      '[Core Statistic Query] Clear Presented Statistic Query';
    constructor(public dataEntityId?: string) {}
  }
}
